// extracted by mini-css-extract-plugin
export default {"create-post":"Form_create-post__rduj3","select":"Form_select__j-GBe"};